import { capabilityRequest } from "../services/capability-client.service";
import { BookingIntentSchema, BookingResultSchema, } from "../models";
export const bookingIntentRepository = {
    async createIntent(apiBaseUrl, orgId, rootGrant, proposal, captchaToken) {
        const data = await capabilityRequest({
            apiBaseUrl,
            accessGrant: rootGrant,
            method: "POST",
            path: `/api/v2/organizations/${orgId}/booking-intents`,
            body: { ...proposal, captchaToken },
        });
        return BookingIntentSchema.parse(data);
    },
    // Sends the exact proposal object used for the intent, without captchaToken,
    // using the one-use booking_create child grant instead of the root.
    async createBooking(apiBaseUrl, intentId, childGrant, proposal) {
        const data = await capabilityRequest({
            apiBaseUrl,
            accessGrant: childGrant,
            method: "POST",
            path: `/api/v2/booking-intents/${encodeURIComponent(intentId)}/bookings`,
            body: proposal,
        });
        return BookingResultSchema.parse(data);
    },
};
export default bookingIntentRepository;
